import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(({
	titleText: {
		fontSize: "32px",
		lineHeight: "24px",
		color: colors.gray[800]
	},
	subtitleText: {
		fontSize: "16px",
		lineHeight: "24px",
		color: colors.purple[800]
	},
	tabs: {
		position: "relative",
		"&::before": {
			content: "close-quote",
			position: "absolute",
			width: "100%",
			height: "1px",
			bottom: 0,
			left: 0,
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		}
	},
	tabIndicator: {
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[600])
	},
	tab: {
		color: `${colors.gray[400]} !important`,
		opacity: 1,
		fontSize: 14
	}
}))

export default useStyles
